import React, { useState, useCallback, useEffect } from "react";
import { getTheme, concatStyleSets } from '@fluentui/react/lib/Styling';
import { DefaultButton, IButtonStyles } from '@fluentui/react/lib/Button';
import { Link } from 'react-router-dom';

const theme = getTheme();

const menuStyles: IButtonStyles = {
  label: { fontSize: 14, fontWeight: 'normal', borderWidth: 0 }, 
  icon: {color: theme.palette.blueLight}, 
  iconExpanded: {color: theme.palette.blueLight}, 
  iconPressed: {color: theme.palette.blueLight},
  root: {borderWidth: 0, minWidth: "125px"},
  };

const servicesMenuItems = [
  {
    key: 'demandmanagement',
    text: 'Demand Management',
    iconProps: { iconName: 'ManagerSelfService' },
    href: "/demandmanagement",
    menuStyles: { menuStyles }
  },
   {
    key: 'ordermanagement',
    text: 'Order Management',
    iconProps: { iconName: 'ManagerSelfService' },
    href: "/ordermanagement",
    menuStyles: { menuStyles }
  },
  {
    key: 'inventorymanagement',
    text: 'Inventory Management',
    iconProps: { iconName: 'ManagerSelfService' },
    href: "/inventorymanagement",
    menuStyles: { menuStyles }
  },
  {
    key: 'datamanagement',
    text: 'Data Management',
    iconProps: { iconName: 'ManagerSelfService' },
    href: "/datamanagement",
    menuStyles: { menuStyles }
  },
];

const orgMenuItems = [
  {
    key: 'locations',
    text: 'Locations',
    iconProps: { iconName: 'Location' },
    href: "/locations",
    menuStyles: { menuStyles }
  },
];

const careersMenuItems = [
  {
    key: 'careers',
    text: 'Careers',
    iconProps: { iconName: 'People' },
    href: "/careers",
    menuStyles: { menuStyles }
  },
];

const programsMenuItems = [
  {
    key: 'healthxm',
    text: 'HealthXM',
    iconProps: { iconName: 'PeopleRepeat' },
    href: "/healthxm",
    menuStyles: { menuStyles }
  },
];

export const AppMenu: React.FunctionComponent = () => {
    return (
       <nav>
        <Link to="/"><DefaultButton styles={menuStyles} iconProps={{iconName: 'Home'}}  aria-label="Home" text="Home" disabled={false}/></Link>        
        <DefaultButton styles={menuStyles} iconProps={{iconName: 'AccountManagement'}} menuProps={{items: servicesMenuItems}} aria-label="Services" text="Services" disabled={false}/>
        <DefaultButton styles={menuStyles} iconProps={{iconName: 'AddGroup'}} menuProps={{items: programsMenuItems}} aria-label="Programs" text="Programs" disabled={false}/>
        <DefaultButton styles={menuStyles} iconProps={{iconName: 'SplitObject'}} menuProps={{items: orgMenuItems}} aria-label="Organization" text="Organization" disabled={false}/>
        <DefaultButton styles={menuStyles} iconProps={{iconName: 'People'}} menuProps={{items: careersMenuItems}} aria-label="Careers" text="Careers" disabled={false}/>
      </nav>
  );
};